function ignoreReason() {
  // intentionally left empty
}

export function unawaited<T>(p?: Promise<T> | void): void {
  if (typeof p?.catch === 'function') {
    p.catch(ignoreReason);
  }
}
